import React, { useEffect } from "react";
import { useState } from "react";
import DropDown from "../_default/DropDown";
import Input from "../_default/Input";
import "./RepetitionMeximumCalculator.scss";
export default function RepetitionMeximumCalculator() {
  const [load, setLoad] = useState("");
  const [repsPerformed, setRepsPerformed] = useState("");
  const [repMax, setRepMax] = useState("");
  const [estimatedReps, setEstimatedReps] = useState("");

  let reps = [
 
    "1",
    "2",
    "3",
    "4",
    "5",
    "6",
    "7",
    "8",
    "9",
    "10",
    "11",
    "12",
    "13",
    "14",
    "15",
    "16",
    "17",
    "18",
    "19",
    "20",
  ];
  let rmpercent = [
   
    100,
    94.5,
    90,
    87.5,
    85,
    82.5,
    80,
    78,
    76,
    74,
    72,
    70,
    68.5,
    67,
    65.5,
    64,
    63,
    62,
    61,
    60,
  ];
  const repsObj={
    reps:[
      "Reps",
      "1",
      "2",
      "3",
      "4",
      "5",
      "6",
      "7",
      "8",
      "9",
      "10",
      "11",
      "12",
      "13",
      "14",
      "15",
      "16",
      "17",
      "18",
      "19",
      "20",
    ],
    rmpercent :[
      "%RM",
      "100%",
      "94%",
      "90%",
      "88%",
      "85%",
      "83%",
      "80%",
      "78%",
      "76%",
      "74%",
      "72%",
      "70%",
      "68%",
      "67%",
      "66%",
      "65%",
      "63%",
      "62%",
      "61%",
      "60%",
    ]
  }
  const handelRepsPerformed=(e)=>{
    setRepsPerformed(e)
    let parseVal=parseInt(e)
    console.log("parsed value",parseVal)
    parseVal-=1
    let calcProjectedLoad=(((100/rmpercent[parseVal])*load)).toFixed(2)
    setRepMax(rmpercent[parseVal]+"%")
    // setRepMax(calcProjectedLoad)
    setEstimatedReps(calcProjectedLoad)
    // reps.map((data)=>{
    //   console.log("data reps",(((rmpercent[data]/100)*138.89)).toFixed(2))
    // })

  }
  const handelSetLoad=(e)=>{
    console.log("value ",e.target.value)
    let load=e.target.value
    let parseLoad = load.replace(/,/g, ".");
    // let val=parseInt(e.target.value)
    let val=parseFloat(parseLoad)
    // setEstimatedReps(rmpercent[0]+"%")
    setEstimatedReps((((100/rmpercent[0])*val)).toFixed(2))
    setRepMax(rmpercent[0]+"%")
    setLoad(val)
    // let rmpercentFormula=((rm/100)*val)
   
  }
  useEffect(()=>{
    setLoad(load)
 
  },[load])
  return (
    <>
      <h2 className="repetition-Calc-heading">Repetition Maximum Calculator</h2>

      <div
        className="calorie-count"
        style={{ background: "#dde0e8", width: "98%", marginTop: "unset" }}
      >
        <div className="c-rep-wrapper">
          <div className="c-rep-input">
            <label className="c-rep-input-label">Load Used</label>

            <input
              className="c-input-macro-calc"
              type="text"
              onChange={handelSetLoad}
            />
          </div>
          <div className="c-rep-input">
            <label className="c-rep-input-label">Reps Performed</label>
            <DropDown options={reps} onChange={(e)=>{handelRepsPerformed(e)}} value={repsPerformed} />
          </div>
          <div className="c-rep-input">
            <label className="c-rep-input-label">% 1 Rep Max</label>

            <input className="c-input-macro-calc" type="text" value={repMax} />
          </div>
          <div className="c-rep-input">
            <label className="c-rep-input-label">Estimated 1 Rep Max</label>

            <input className="c-input-macro-calc" type="text" value={estimatedReps} />
          </div>
        </div>
        <div className="c-rep-wrapper" style={{ marginTop: "20px" }}></div>
      </div>
      <h2 className="repetition-Calc-heading">Repetition Maximum Projection</h2>
      <div
        className="table-div-count"
        style={{ background: "#dde0e8", width: "98%", marginTop: "unset" }}
      >
      
        {/* <div style={{display:"flex",flexDirection:"row"}}>
          <div style={{width:"10%"}}>Reps
          {
            reps.map((rep)=>
               <p className="rep-p-tag">{rep}</p>
            )
          }
          
          </div>
          <div style={{width:"15%"}}>%RM
          {
            rmpercent.map((rm)=><p className="rep-p-tag">{rm}%</p>)
          }
          </div>

          <div style={{width:"20%"}}><h5 style={{textAlign:"center"}} >Projected Load</h5>
          {rmpercent.map((rm)=><input className="input-projected-load"  value={(((rmpercent/100)*load))?(((rmpercent/100)*load)).toFixed(2):0.00} />)}
          </div>
          
          
            
          </div> */}
          



          <ul className="w-100 responsive-table">
          <li className="table-header">
            <div className="col col-1">Reps</div>
            <div className="col col-2">%RM</div>
            <div className="col col-3"><div style={{textAlign:"center"}} >Projected Load</div></div>
          </li>
          
          {
          estimatedReps?
          reps.map((data,i)=>{
            return <li className="table-row">
            <div className="col col-1"  style={{fontSize:"14px",fontWeight:"700"}}>{data}</div>
            <div className="col col-2" style={{fontSize:"14px",fontWeight:"700"}}>{rmpercent[i]}%</div>
            <div className="col col-3" style={{textAlign:"center"}}><input  style={{textAlign:"center"}} className="input-projected-load"  value={(((rmpercent[i]/100)*load))?(((rmpercent[i]/100)*parseFloat(estimatedReps))).toFixed(2):0.00} /></div>
            </li>
            
          }):
          reps.map((data,i)=>{
            return <li className="table-row">
            <div className="col col-1"  style={{fontSize:"14px",fontWeight:"700"}}>{data}</div>
            <div className="col col-2" style={{fontSize:"14px",fontWeight:"700"}}>{rmpercent[i]}%</div>
            <div className="col col-3" style={{textAlign:"center"}}><input  style={{textAlign:"center"}} className="input-projected-load"  value={(((rmpercent[i]/100)*load))?(((parseInt(rmpercent[i])/100)*load)).toFixed(2):0.00} /></div>
            </li>
            
          })
          }
              </ul>

           

         {/* <table style={{width:"79%",textAlign:"center"}}>
          <thead>
            <tr>

            <th >Reps</th>
            <th >%RM</th>
            <th  >Projected Load</th>
            </tr>
          </thead>
          <tbody>
          {reps.map((rep,i) => {
              return <tr >
                <td ><p className="rep-p-tag">{rep}</p></td>
                <td  >
                <p className="rep-p-tag">{rmpercent[i]}%</p>
                </td>
                <td>

                <input className="input-projected-load"  value={(((rmpercent[i]/100)*load))?(((rmpercent[i]/100)*load)).toFixed(2):0.00} />
                </td>
              </tr>
            })}
          </tbody>
         </table> */}
       
      </div>

      {/* <div className="rm-flex-wrapper">
                <div className="reps-wrapper">Reps
                {
                  reps.map((rep)=>{
                    return <p className="reps">{rep}</p>
                  })
                }
                </div>
                <div className="rm-wrapper" >%RM
                {
                  rmpercent.map((rm)=>{
                    return <p className="rm">{rm}%</p>
                  })
                }
                </div>
                <div className="projected-load-wrapper">Projected Load
                {
                  rmpercent.map((rm)=>{
                    return <input   className="input-projected-load"  value={(((rm/100)*load))?(((rm/100)*load)).toFixed(2):0.00} />
                  })
                }
                </div>
              </div> */}
    </>
  );
}
